import { createContext, useContext } from 'react'
import { Currency } from '../../model'

export interface StickyCurrencies {
  first: Currency
  second: Currency
}

export const StickyCurrenciesContext = createContext<{
  stickyCurrencies: StickyCurrencies
  setStickyCurrencies: (stickyCurrencies: StickyCurrencies) => void
}>(null as any)

export function useStickyCurrencies() {
  return useContext(StickyCurrenciesContext)
}
